module.exports = __webpack_public_path__ + "static/saude-5e7a4fbc038991f29835616e0f81aceb.png";